/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleDispatchStatuses } from './equipment-schedule-dispatch-statuses';


export interface EquipmentScheduleLastCommandDto { 
    dueAt?: string;
    modeId?: number | null;
    scheduleId?: string | null;
    scheduleName?: string | null;
    status?: EquipmentScheduleDispatchStatuses;
    reasonCode?: string | null;
}



